<p-button
  [styleClass]="type + ' w-full hover:transform hover:scale-105 transition-all'"
  [label]="label"
  [icon]="renderedIcon()"
  [iconPos]="iconPosition()"
  [pTooltip]="tooltipLabel"
  [positionTop]="10"
  tooltipPosition="bottom"
  [tooltipOptions]="tooltipOptions"
  [ariaLabel]="label || icon()"
  [badge]="badges"
  [disabled]="disable"
  type="{{ buttonType }}"
></p-button>
